export const gettingCenters = (state: any) => state.gettingCenters;
export const fetchCenters = (state: any) => state.centers;
export const getCentersError = (state: any) => state.getCentersError;
